import orderReducer from "./order";
import menuReducer from "./menu";
import searchReducer from "./search";
import hotelReducer from "./hotel";
import languageReducer from "./language";
export default { orderReducer, menuReducer, searchReducer, hotelReducer,languageReducer };
